import { Injectable } from "@angular/core";
import { RealtimeSeverity } from "../../../models/ws/realtimeSeverity";
import {
  RealtimeSubscriptionHandle,
  RealtimeSubscriptionRequest,
  RealtimeSubscriptionService,
} from "../realtime-subscription.service";

export interface SeveritySubscriptionDescriptor extends RealtimeSubscriptionRequest {
  customerIds: readonly string[];
}

export type SeveritySubscriptionHandle = RealtimeSubscriptionHandle<RealtimeSeverity, SeveritySubscriptionDescriptor>;

@Injectable({
  providedIn: "root",
})
export class SeverityService extends RealtimeSubscriptionService<RealtimeSeverity, SeveritySubscriptionDescriptor> {
  protected readonly PATH = "severity";
  protected readonly VERSION = 1;
}
